import { Box, TextField } from "@mui/material/";

import "./../genericModels.css";
import { DateTimePicker } from "@mui/x-date-pickers";

import { useTranslation } from "react-i18next";
import GenericFilterBox from "../common/GenericFilterBox";
import { Autocomplete } from "@mui/material";
import { useMemo, useState } from "react";
import { importTrackingActions } from "../../service/importtracking.actions";

export const SapImportFilterAndSearch = (props: any) => {
  const [statusList, setStatusList] = useState<any>([]);

  let dataFormSearchFieldImportTracking =
    props.dataFormSearchFieldImportTracking;
  let setDataFormSearchFieldImportTracking =
    props.setDataFormSearchFieldImportTracking;
  let resetFormTextImportTracking = props.resetFormTextImportTracking;
  console.log(resetFormTextImportTracking, "resetFormTextImportTracking");

  const { t } = useTranslation(["operation"]);

  const changeStatusName = (statusName: string) => {
    switch (statusName) {
      case "PROCESSED":
        return t("internOptionSelectName.statusType.processed");
      case "PENDING":
        return t("internOptionSelectName.statusType.pending");
      case "WITH_ERRORS_CSV_FORMAT":
        return t("internOptionSelectName.statusType.csvError");
      case "WITH_ERRORS_DATA_INTEGRITY":
        return t("internOptionSelectName.statusType.dataIntegrityError");
      case "WITH_ERRORS_GENERIC_ERROR":
        return t("internOptionSelectName.statusType.genericError");
      default:
        return "";
    }
  };
  const Search = (e: any) => {
    e.preventDefault();
    props.setResetFormValueImportTracking(!props.resetFormValueImportTracking);
  };

  useMemo(() => {
    importTrackingActions()
      .statusList()
      .then((response) => setStatusList(response.data));
  }, []);

  return (
    <>
      <form id="idSapForm" onSubmit={(e) => Search(e)}>
        <GenericFilterBox
          formId="idSapForm"
          onReset={resetFormTextImportTracking}
          showExtrasFilters={true}
        >
          <Box>
            <TextField
              fullWidth
              //placeholder={t("sapImport.enterFileName")}
              label={t("sapImport.fileName")}
              variant="standard"
              id="fileName"
              name="fileName"
              value={dataFormSearchFieldImportTracking.fileName}
              onChange={(e: any) =>
                setDataFormSearchFieldImportTracking({
                  ...dataFormSearchFieldImportTracking,
                  fileName: e.target.value,
                })
              }
              inputProps={{
                pattern: "[^%*$\"+&?^~Â`£=!@'/§#]{0,}",
                onInput: (event) => {
                  if (event.currentTarget.validity.patternMismatch) {
                    event.currentTarget.setCustomValidity(
                      t("vehicle.filterModal.regexMessage")
                    );
                  } else {
                    event.currentTarget.setCustomValidity("");
                  }
                },
              }}
            />
          </Box>
          <Box>
            <DateTimePicker
              label={t("sapImport.startDate")}
              value={dataFormSearchFieldImportTracking.startDateFrom}
              onChange={(e) => {
                setDataFormSearchFieldImportTracking({
                  ...dataFormSearchFieldImportTracking,
                  startDateFrom: e,
                });
              }}
              mask={"__/__/____ __:__"}
              inputFormat={"DD/MM/YYYY HH:mm"}
              ampm={false}
              renderInput={(params) => (
                <TextField
                  variant="standard"
                  fullWidth
                  {...params}
                  name="startDateFrom"
                />
              )}
            />
          </Box>
          <Box>
            <DateTimePicker
              label={t("sapImport.endDate")}
              value={dataFormSearchFieldImportTracking.startDateTo}
              onChange={(e) => {
                setDataFormSearchFieldImportTracking({
                  ...dataFormSearchFieldImportTracking,
                  startDateTo: e,
                });
              }}
              mask={"__/__/____ __:__"}
              inputFormat={"DD/MM/YYYY HH:mm"}
              ampm={false}
              renderInput={(params) => (
                <TextField variant="standard" fullWidth {...params} />
              )}
            />
          </Box>
          <Box>
            <Autocomplete
              disablePortal
              sx={{
                "&.MuiAutocomplete-root": {
                  "& button[title='Clear']": {
                    visibility: "visible",
                  },
                },
              }}
              disableClearable={
                !!dataFormSearchFieldImportTracking.status ? false : true
              }
              id="status"
              value={dataFormSearchFieldImportTracking.status}
              options={statusList?.map((response: any) => response)}
              getOptionLabel={(option: any) => changeStatusName(option)}
              onChange={(e, value) => {
                if (e === null) {
                  setDataFormSearchFieldImportTracking({
                    ...dataFormSearchFieldImportTracking,
                    status: " ",
                  });
                  props.SearchImportTracking();
                } else {
                  setDataFormSearchFieldImportTracking({
                    ...dataFormSearchFieldImportTracking,
                    status: value,
                  });
                }
              }}
              renderInput={(params: any) => (
                <TextField
                  fullWidth
                  variant="standard"
                  {...params}
                  label={t("sapImport.placeholderStatus")}
                />
              )}
              renderOption={(props, option, state) => {
                return (
                  <li {...props} key={props.id}>
                    {changeStatusName(option)}
                  </li>
                )
              }}
            />
          </Box>
        </GenericFilterBox>
      </form>
    </>
  );
};
